import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

export default function Members() {
  return (
    <div className="cnt-3" id="members">
      <div className="title-members"> Members</div>
      <div className="members-wrapper">
        <ul className="members-split">
          <li className="members-left"></li>
          {/* image&menbers */}
          <li className="members-right">
            <Container className="mem-container">
              <Row className="mem mem-1">
                <Col className="left-1"></Col>
                <Col className="right-1">
                  <div className="mem-alpha">TOMOKI MASUKO</div>
                  <div className="mem-name">増子 知希</div>
                  <div className="mem-role">代表取締役／プロデューサー</div>
                </Col>
              </Row>
              <Row className=" mem mem-2">
                <Col className="left-2">
                  <div className="mem-alpha">MASAKI NISHIURA</div>
                  <div className="mem-name">西浦 正記</div>
                  <div className="mem-role">執行役員／監督</div>
                  <div className="mem-titles">
                    （CX「コード・ブルー
                    -ドクターヘリ緊急救命-」シリーズ、WOWOW「華麗なる一族」他）
                  </div>
                </Col>
                <li className="right-2"></li>
              </Row>
              <Row className="mem mem-3">
                <Col className="left-3"></Col>
                <Col className="right-3">
                  <div className="mem-alpha">RYOHEI TAKADA</div>
                  <div className="mem-name">高田 良平</div>
                  <div className="mem-role">執行役員／プロデューサー</div>
                </Col>
              </Row>
              <Row className="mem mem-4">
                <Col className="left-4">
                  <div className="mem-alpha">NOZOMI KAMAKURA</div>
                  <div className="mem-name">鎌倉 希</div>
                  <div className="mem-role">プロデューサー</div>
                </Col>
                <Col className="right-4"></Col>
              </Row>
            </Container>
          </li>
        </ul>
      </div>
    </div>
  );
}
